// This should be a global polyfill. Currently not working

export default () => typeof IntersectionObserver !== 'undefined';
